import { AxiosError } from "axios";

import i18n from "@/i18n";
import { addNotification, NotificationType } from "@/models/notification.model";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconError } from "@/interfaces/http/falcon-error";

import { ResponseInterceptor } from "@/types/http/response-interceptor";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

export const errorResponseToastInterceptor: ResponseInterceptor = {
  onRejected(error: AxiosError): any {
    let errorMessage: string;
    if (error.response?.status === 401) {
      // Unauthorized
      errorMessage = i18n.t(
        I18nMessageKey.SharedHttpErrorUnauthorizedText
      ) as string;
    } else if ((error.response?.data as FalconError).error?.code) {
      // Falcon error
      errorMessage = (error.response?.data as FalconError).error?.msg as string;
    } else {
      // Uncategorized error
      errorMessage = i18n.t(
        I18nMessageKey.SharedHttpErrorUncategorizedText
      ) as string;
    }
    addNotification({
      message: capitalizeFilter.capitalize(errorMessage),
      type: NotificationType.Error
    });
    return Promise.reject(error);
  }
};
